import React, { useEffect, useMemo } from "react";
import "./MedecinInformation.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Image } from "antd";

import { getCurrentDoctor } from "../../../../authDoctor/redux/thunks/doctorsThunks";
import useDoctorInformation from "@/ProfileDoctor/hooks/useDoctorInformation";
import medecinMailIcon from "../../../../assets/icons/svg/medecin-mail.svg";
import medecinPhoneIcon from "../../../../assets/icons/svg/medecin-phone.svg";

// Normaliser la spécialité (comme dans ChatHeader)
const normalizeSpecialtyKey = (value) => {
  if (!value) return null;
  const norm = value.toString().trim().toLowerCase();
  if (!norm) return null;

  if (norm.includes("dermatolog")) return "dermatology";
  if (norm.includes("pediatr")) return "pediatrics";
  if (norm.includes("cardiolog")) return "cardiology";
  if (norm.includes("neurolog")) return "neurology";
  if (norm.includes("psychiatr")) return "psychiatry";
  if (norm.includes("ophthalmolog") || norm.includes("ophtalmolog")) return "ophthalmology";
  if (norm.includes("orthop")) return "orthopedics";
  if (norm.includes("gynecolog") || norm.includes("gynaecolog")) return "gynecology";
  if (norm.includes("dentist")) return "dentistry";
  if (norm.includes("general")) return "general";
  if (norm === "ent" || (norm.includes("ear") && norm.includes("nose") && norm.includes("throat"))) return "ent";
  return null;
};

/* ================= ICONS ================= */

const MailIcon = () => <img src={medecinMailIcon} className="mi-ico" alt="" aria-hidden="true" />;

const PhoneIcon = () => <img src={medecinPhoneIcon} className="mi-ico" alt="" aria-hidden="true" />;

const PencilIcon = (props) => (
  
  
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
  <path
      d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
      stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
);

/* ================= COMPONENT ================= */

export default function MedecinInformation({ onEdit = () => {}, showEdit = true }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user: currentUser } = useSelector((state) => state.doctor);

  // ✅ hook qui construit une URL exploitable à partir du path avatar
  const { avatarSrc } = useDoctorInformation(currentUser);

  useEffect(() => {
    dispatch(getCurrentDoctor());
  }, [dispatch]);

  const { fullName, specialty, email, phone, about } = {
    fullName:
      `${currentUser?.firstName || ""} ${currentUser?.lastName || ""}`.trim() ||
      currentUser?.fullName ||
      "Doctor",
    specialty: currentUser?.specialty || "General Practitioner",
    email: currentUser?.email || "email",
    phone: currentUser?.phone || "+41 (0) 620-4457",
    about:
      currentUser?.about ||
      "Board-certified endocrinologist with over 12 years of experience...",
  };

  return (
    <section className="mi-card" role="region" aria-label="Doctor profile header">
      <div className="mi-toprow">
        <div className="mi-left">
          {/* Avatar harmonisé ContactsList */}
          {avatarSrc ? (
            <Image
              src={avatarSrc || undefined}
              width={96}
              height={94}
              preview={false}
              className="mi-avatar"
              fallback="https://cdn-icons-png.flaticon.com/512/149/149071.png"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <div className="ch-avatar--placeholder" style={{background:'#2563eb',color:'#fff',display:'grid',placeItems:'center',fontWeight:'700',fontSize:'32px',borderRadius:'50%',width:'96px',height:'94px'}}>
              {(() => {
                // ContactsList logic for initials
                const name = currentUser?.fullName || currentUser?.name || `${currentUser?.firstName || ""} ${currentUser?.lastName || ""}`.trim() || currentUser?.email || "?";
                const first = currentUser?.firstName?.[0] || name.split(" ")[0]?.[0] || "";
                const last = currentUser?.lastName?.[0] || name.split(" ").slice(1).join(" ")[0] || "";
                return (first + last).toUpperCase() || "?";
              })()}
            </div>
          )}

          <div className="mi-id">
            <h3 className="mi-name">Dr. {fullName}</h3>
            <div className="mi-sub">
              {useMemo(() => {
                const specialtyKey = normalizeSpecialtyKey(specialty);
                if (specialtyKey) {
                  return t(`doctorFinder.specialties.${specialtyKey}`);
                }
                return specialty;
              }, [specialty, t])}
            </div>

            <div className="mi-contact">
              <span className="mi-item">
                <MailIcon className="mi-ico" />
                <a href={`mailto:${email}`} className="mi-link">
                  {email}
                </a>
              </span>
              <span className="mi-sep">•</span>
              <span className="mi-item">
                <PhoneIcon className="mi-ico" />
                <a href={`tel:${phone}`} className="mi-link">
                  {phone}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



